module.exports = __webpack_public_path__ + "img/tab-3.cfe813c7.png";